import { render, staticRenderFns } from "./AnalyticsTableSection.vue?vue&type=template&id=0c134d28&scoped=true&"
import script from "./AnalyticsTableSection.vue?vue&type=script&lang=js&"
export * from "./AnalyticsTableSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c134d28",
  null
  
)

export default component.exports